<template>
  <div class="hidden">
    <div class="confirmBox ">
      <h1>{{_lang[$route.query.type].zhen_29}}</h1>
      <p>{{_lang[$route.query.type].zhen_30}}</p>
      <div class="m_clearLR confirmBtn">
        <div class="m_floatL zhen_13" @click="cancel">{{_lang[$route.query.type].zhen_13}}</div>
        <div class="m_floatR zhen_14" @click="confirm">{{_lang[$route.query.type].zhen_14}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {lang} from '@/utils/i18n'
export default {
  data(){return{
    _lang:[],
  }},
  
  props:{
    // title:{
    //   type:String,
    //   default:lang[this.$route.query.type].zhen_29
    // },
    // desc:{
    //   type:String,
    //   default:lang[this.$route.query.type].zhen_30
    // }
  },
  created(){
    this._lang = lang
  },
  methods:{
    confirm(){
      this.$emit('confirm')
    },
    cancel(){
      this.$emit('cancel')
    }
  }
}
</script>

<style lang='scss' scoped>
.hidden{
  position: fixed;
  top:0px;
  right: 0px;
  bottom:0px;
  left:0px;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.3);
  .confirmBox{
    background-color: #fff;
    width:5.4rem;
    position: absolute;
    margin:auto;
    left:0px;
    right: 0px;
    top:0px;
    bottom:0px;
    height:2.25rem;
    border-radius: 0.2rem;
    padding-top:0.4rem;
    // margin-top:30%;
    overflow: hidden;
    .confirmBtn{
      display: flex;
      border-top: 1px solid #eeeeee;
      height:0.92rem;
      font-size:0.36rem;
      color:#0497ff;
      text-align: center;
      line-height: 0.92rem;
      margin-top:0.3rem;
      .m_floatL{
        width:50%;
        border-right: 1px solid #eeeeee;
      }
      .m_floatR{
        flex: 1;
      }
    }
    h1{
      text-align: center;
      font-size:0.36rem;
    }
    p{
      font-size:0.28rem;
      text-align: center;
      margin-top:0.05rem;
      color:#666;
    }
  }
}
</style>
